import { render, staticRenderFns } from "./IPSummary.vue?vue&type=template&id=50c88079&scoped=true&"
import script from "./IPSummary.vue?vue&type=script&lang=js&"
export * from "./IPSummary.vue?vue&type=script&lang=js&"
import style0 from "./IPSummary.vue?vue&type=style&index=0&id=50c88079&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c88079",
  null
  
)

export default component.exports